import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { Partner } from "types";
import { NoTranslate } from "../../../components/Common/NoTranslate";
import { ColumnLayout } from "../../../components/Layout/ColumnLayout";
import { PartnerStatement } from "../../../components/Reports/PartnerCommissions/PartnerStatement/PartnerStatement";
import { useResource } from "../../../hooks/useResource";
import { Page } from "../../Page";

export const AgentStatementPage = () => {
    const history = useHistory();
    const { agentId } = useParams<{ agentId: ID }>();

    const handleClick = () => {
        history.push("/reports/distributionPartnersReconciliation");
    };

    const { data: partner } = useResource<Partner>(["partners", agentId], { expand: "partnerSeller" });

    return (
        <Page title="Agent Statement">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0 print:hidden">
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>
                            Distribution Partners Reconciliation Report
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <NoTranslate>{partner?.name}</NoTranslate>
                        </Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                {partner && <PartnerStatement partner={partner} />}
            </ColumnLayout>
        </Page>
    );
};
